/**
 * Las cuentas del cierre de la noche: lo que se tira y las botellas abiertas.
 *
 * Aparte de la pantalla porque son las que pueden salir mal en silencio: un
 * «media» que se guarda como media unidad de mililitro deja la barra con 374
 * botellas de pisco menos y nadie lo ve hasta el próximo conteo.
 */

/** Lo que se le pregunta a quien mira la botella a contraluz. */
export const FRACCIONES: readonly { texto: string; valor: number }[] = [
  { texto: 'Nada', valor: 0 },
  { texto: 'Un cuarto', valor: 0.25 },
  { texto: 'Media', valor: 0.5 },
  { texto: 'Tres cuartos', valor: 0.75 },
];

/**
 * En qué se cuenta ese insumo en la barra.
 *
 * Si se compra por botella con su equivalencia —«botella de 750 ml»—, se
 * cuenta en botellas y se guarda en mililitros. Si el insumo ya se lleva en
 * botellas, la botella es la unidad. Sin equivalencia no se puede convertir:
 * una fracción de «botella» sin saber cuánto trae no es un número.
 */
export function botellaDe(supply: {
  unit: string;
  purchaseUnit: string | null;
  purchaseFactor: string | null;
}): { nombre: string; factor: number } {
  const factor = Number.parseFloat(supply.purchaseFactor ?? '');

  if (supply.purchaseUnit !== null && Number.isFinite(factor) && factor > 0) {
    return { nombre: supply.purchaseUnit, factor };
  }
  return { nombre: supply.unit, factor: 1 };
}

/**
 * Lo contado, en la unidad del insumo y como texto, que es como viaja.
 *
 * Tres decimales como mucho, igual que guarda el almacén: 0,75 × 750 ml son
 * 562,5 ml y no 562,50000001.
 */
export function contadoEnBotellas(enteras: number, fraccion: number, factor: number): string {
  const botellas = Math.max(0, Math.trunc(enteras)) + fraccion;
  const contado = Math.round(botellas * factor * 1000) / 1000;

  return String(contado);
}

/** Una fila de merma de la noche, como la escribe la pantalla. */
export interface FilaDeMerma {
  clave: string;
  supplyId: string;
  cantidad: string;
}

/**
 * ¿Se puede mandar esta fila? Con insumo y una cantidad mayor que cero.
 *
 * Una fila vacía se ignora, no se rechaza: en el celular se deja la última
 * en blanco para la siguiente, y eso no tiene que impedir registrar las otras.
 */
export function filaLista(fila: FilaDeMerma): boolean {
  const cantidad = Number.parseFloat(fila.cantidad.replace(',', '.'));
  return fila.supplyId !== '' && Number.isFinite(cantidad) && cantidad > 0;
}

export function filaEnBlanco(fila: FilaDeMerma): boolean {
  return fila.supplyId === '' && fila.cantidad.trim() === '';
}
